module.exports = __webpack_public_path__ + "media/images/emblems/Tumbnail.asp-2f680efee74b4c8ab929ae693bc7c7c4.png";